export const Cataloge = ({ enName, faName }) => {
  return (
    <>
      <div className="brand-chip">
        {enName} <span>{faName}</span>
      </div>
    </>
  );
};
